import type { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

export class HsKeyboardControlAction extends HsControlAction {
  constructor(
    public readonly actionType: HsControlActionType,
    isActive: boolean = false,
    public movementScale: number = 1
  ) {
    super();
    this.isActive = isActive;
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsKeyboardControlAction)) {
      return;
    }

    this.isActive = controlAction.isActive;
    this.movementScale = controlAction.movementScale;
  }

  public override setInactive(): void {
    return;
  }
}
